import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// --- Professional Styles for the PDF ---
const styles = StyleSheet.create({
    page: { padding: 30, fontFamily: 'Helvetica', fontSize: 10, color: '#333' },
    header: { fontSize: 20, marginBottom: 20, textAlign: 'center', color: '#2C3E50', fontFamily: 'Helvetica-Bold' },
    section: { marginBottom: 15, border: '1px solid #EAEAEA', borderRadius: 5, overflow: 'hidden' },
    sectionTitle: { fontSize: 14, padding: 8, color: 'white', backgroundColor: '#18BC9C', fontFamily: 'Helvetica-Bold' },
    content: { padding: 10 },
    kpiContainer: { flexDirection: 'row', justifyContent: 'space-around', paddingVertical: 10 },
    kpiBox: { alignItems: 'center', width: '25%' },
    kpiValue: { fontSize: 16, fontFamily: 'Helvetica-Bold' },
    kpiLabel: { fontSize: 9, color: '#7F8C8D', marginTop: 2 },
    table: { display: 'table', width: 'auto', marginTop: 10 },
    tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eee', alignItems: 'center' },
    tableHeader: { backgroundColor: '#f2f2f2' },
    tableColHeader: { width: '50%', padding: 5, fontFamily: 'Helvetica-Bold' },
    tableCol: { width: '50%', padding: 5 },
    tableColHeaderNum: { width: '25%', padding: 5, fontFamily: 'Helvetica-Bold', textAlign: 'center' },
    tableColNum: { width: '25%', padding: 5, textAlign: 'center' },
    footer: { position: 'absolute', bottom: 30, left: 30, right: 30, textAlign: 'center', color: 'grey', fontSize: 8 },
});

const ReporteGeneralPDF = ({ proyectos, inventario, compras }) => {
    const proyectosEnProceso = proyectos.filter(p => p.estado === 'En Proceso').length;
    const proyectosRetrasados = proyectos.filter(p => p.estado === 'Retrasado').length;
    const proyectosCompletados = proyectos.filter(p => p.estado === 'Completado').length;
    const itemsBajoStock = inventario.filter(item => (item.stockMinimo > 0) && (item.cantidad <= item.stockMinimo));
    const costoTotalCompras = compras.reduce((total, compra) => total + (compra.costoTotal || 0), 0);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Text style={styles.header}>Reporte de Control Logístico</Text>

                {/* --- Project Data Section --- */}
                <View style={styles.section} wrap={false}>
                    <Text style={styles.sectionTitle}>Visión General de Proyectos</Text>
                    <View style={styles.content}>
                        <View style={styles.kpiContainer}>
                            <View style={styles.kpiBox}><Text style={styles.kpiValue}>{proyectos.length}</Text><Text style={styles.kpiLabel}>Totales</Text></View>
                            <View style={styles.kpiBox}><Text style={styles.kpiValue}>{proyectosEnProceso}</Text><Text style={styles.kpiLabel}>En Proceso</Text></View>
                            <View style={styles.kpiBox}><Text style={styles.kpiValue}>{proyectosRetrasados}</Text><Text style={styles.kpiLabel}>Retrasados</Text></View>
                            <View style={styles.kpiBox}><Text style={styles.kpiValue}>{proyectosCompletados}</Text><Text style={styles.kpiLabel}>Completados</Text></View>
                        </View>
                    </View>
                </View>

                {/* --- Inventory Section --- */}
                <View style={styles.section} wrap={false}>
                    <Text style={styles.sectionTitle}>Estado del Inventario</Text>
                    <View style={styles.content}>
                        <Text style={{ marginBottom: 5, fontFamily: 'Helvetica-Bold' }}>⚠️ Alerta de Stock Bajo</Text>
                        {itemsBajoStock.length > 0 ? (
                            <View style={styles.table}>
                                <View style={[styles.tableRow, styles.tableHeader]}>
                                    <Text style={styles.tableColHeader}>Artículo</Text>
                                    <Text style={styles.tableColHeaderNum}>Actual</Text>
                                    <Text style={styles.tableColHeaderNum}>Mínimo</Text>
                                </View>
                                {itemsBajoStock.map(item => (
                                    <View style={styles.tableRow} key={item.id || item.nombre}>
                                        <Text style={styles.tableCol}>{item.nombre}</Text>
                                        <Text style={styles.tableColNum}>{item.cantidad}</Text>
                                        <Text style={styles.tableColNum}>{item.stockMinimo}</Text>
                                    </View>
                                ))}
                            </View>
                        ) : (<Text style={{ textAlign: 'center', color: '#7F8C8D', padding: 10 }}>No hay artículos con stock bajo.</Text>)}
                    </View>
                </View>

                {/* --- Purchases Section --- */}
                 <View style={styles.section} wrap={false}>
                    <Text style={styles.sectionTitle}>Resumen de Compras</Text>
                    <View style={styles.content}>
                        <View style={styles.kpiContainer}>
                            <View style={styles.kpiBox}><Text style={styles.kpiValue}>{costoTotalCompras.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}</Text><Text style={styles.kpiLabel}>Costo Total</Text></View>
                            <View style={styles.kpiBox}><Text style={styles.kpiValue}>{compras.length}</Text><Text style={styles.kpiLabel}>Órdenes Realizadas</Text></View>
                        </View>
                    </View>
                </View>

                <Text style={styles.footer}>Documento generado por Hoppy Time App el {new Date().toLocaleDateString('es-ES')}</Text>
            </Page>
        </Document>
    );
};

export default ReporteGeneralPDF;